import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoProductCostVM } from '../../../Model/cost-calculation/DtoProductCostVM';
import { CostCalculationService } from '../../../Services/cost-calculation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { DtoOrderInfoVM } from '../../../Model/cost-calculation/MakeSectorsOrder/DtoOrderInfoVM';
import { DownloadService } from '../../../Services/download.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import { CostCalculationVM } from '../../../Model/cost-calculation/CostCalculationVM';
import { ProductMeterCostVM } from '../../../Model/cost-calculation/ProductMeterCostVM';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-how-to-cut-sticks',
  templateUrl: './how-to-cut-sticks.component.html',
  styleUrl: './how-to-cut-sticks.component.scss'
})
export class HowToCutSticksComponent {
  @Output() IsHowToCutSticks = new EventEmitter<boolean>();
  @Input() TotalCostInputData: CostCalculationVM[] = [];
  @Input() SectorId: string | null = null;
  HowToCutSticksData: DtoProductCostVM[] = [];
  OrderInfoData: DtoOrderInfoVM = {};

  constructor(private api: CostCalculationService, private download: DownloadService,
    private spinner: NgxSpinnerService, private auth: AuthService, private shared: SharedService,
    private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      this.intOrderInfo();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  intOrderInfo() {
    this.HowToCutSticksData = this.api.GetDtoProductCostArrVM(this.TotalCostInputData);
    this.GetOrderInfo();
  }

  GetOrderInfo() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      let data = {'sectorId': this.SectorId, 'products': this.HowToCutSticksData};
      this.api.GetOrderInfo(data)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.OrderInfoData = data;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  exportPDF() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.download.HowToCutToPdf(this.HowToCutSticksData)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.shared.downloadBlobFile(data, 'HowToCut');
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ClacNumberOfMeters(width?: number, height?: number) {
    return this.shared.ClacNumberOfMeters(width, height);
  }

  GetMeterCost(meterCosts?: ProductMeterCostVM[], index?: number) {
    if (meterCosts) {
      index = index ?? 1;
      return meterCosts![index]?.meterCost
    }
    return 0;
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBack',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.IsHowToCutSticks.emit(false);
      }
    });
  }
}
